export default __webpack_public_path__ + "static/desktop_KV14-4bb2446b85ab59e08af12922ac7709bc.mp4";